module.exports = __webpack_public_path__ + "img/reject.95064daa.png";